module.exports = __webpack_public_path__ + "img/logo_lomexin.099b0aa0.svg";